<p-card header="ProcessarDocumentos">

  <div class="p-fluid">
    <div class="p-grid">
      <div class="p-col-12 p-lg-2">
        <label for="id">Fonte de Dados:</label>
      </div>
      <div class="p-col-12 p-lg-10">
        <p-dropdown
            placeholder="Favor selecionar a fonte de dados"
            [options]="fonteDadosItens"
            optionLabel= "nome"
            dataKey="id"
            filter="true"
            [(ngModel)]="fonteDados">
          </p-dropdown>
      </div>
    </div>

    <div class="p-grid">
      <div class="p-col-12 p-lg-2">
        <label for="ids">Documentos Ids:</label><br/>
        <span style="font-size: 0.9em">
          Ex: id1,id2,id3<br/>
        </span>
      </div>
      <div class="p-col-12 p-lg-10">
        <textarea pInputTextarea name="ids" rows="10" [disabled]="fonteDados === undefined" [(ngModel)]="ids"></textarea>
      </div>
    </div>

    <div class="p-grid">
      <div class="p-col-12 p-lg-2">
      </div>
      <div class="p-col-12 p-lg-10">
        <button pButton type="button" [disabled]="fonteDados === undefined" (click)="processarDocumentos()" class="p-button-success" label="Processar Documentos"></button>
      </div>
    </div>
  </div>

  <div class="p-fluid" *ngIf="sincronizar">
    <div class="p-grid">
      <p-card header="Lista de ids a serem processados">
        <p-table
          [value]="idsProcessamento"
          responsive="true"
          dataKey="origemId"
          emptyMessage="Nenhum registro encontrado">

          <ng-template pTemplate="header">
            <tr>
              <th style="width: 80px"> Origem Id</th>
              <th style="width: 80px">Situação</th>
              <th style="width: 230px">Resultado</th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-entity>
            <tr>
              <td>{{entity.origemId}}</td>
              <td>
                <span *ngIf="entity.situacao === 'PENDENTE'" class="pi pi-hourglass"></span>
                <span *ngIf="entity.situacao === 'EM_EXECUCAO'" class="pi pi pi-spin pi-spinner"></span>
                <span *ngIf="entity.situacao === 'EXECUTADO'" class="pi pi-check p-text-bold"></span>
              </td>
              <td>
                <span *ngIf="entity.resultado === 'PROCESSADO'" style="color: green">Processada</span>
                <span *ngIf="entity.resultado === 'IGNORADO'" style="color: darkgoldenrod">Ignorado</span>
                <span *ngIf="entity.resultado === 'FALHA'" style="color: red">Falha: {{entity.mensagemErro}}</span>

              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="footer">
            <tr>
                <td colspan="3" style="text-align: right">
                    Quantidade total: {{idsProcessamento.length | number: '': 'pt-BR'}}
                </td>
            </tr>
        </ng-template>
        </p-table>
      </p-card>


    </div>
  </div>


</p-card>
